import React from "react";
import { Navigate, Route } from "react-router-dom";
import { buildHttpReq, mail } from "../common";
import Loading from "../components/Loading";
import swal from "sweetalert";
import { checkAccess, verifyToken } from "../Rest_api/restapi";
interface User {
    email: string,
    accessToken: string
}
export const Protected = (
    { children }: any,

) => {
    
    console.log("Protected");
    const loggedIn = JSON.parse(localStorage.getItem('loggedIn')!);
    //sleep for 2 seconds
    if (loggedIn) {
        console.log("loggedIn", loggedIn);
        console.log("-------------------------");
        return children;
    } else {
        return <Navigate to="/login" />;
    }
}



export const isLoggedIn = () => {
    const loggedIn = localStorage.getItem('loggedIn')!;
    if (loggedIn === 'true') {
        return true;
    } else {
        Navigate({
            to: '/login',
        });
        return false; 
    }
}

export const getAccessToken = () => {
    const token = localStorage.getItem('token');
    return token;
}

export const  getLoggedIn = async(): Promise<boolean> => {
    const loggedIn = localStorage.getItem('loggedIn');
    if (loggedIn === 'true') {
        return (await verifyToken()).status;
    }
    return false;
}

export const setSessionToken = (token: string) => {

    localStorage.setItem('token', token);
    localStorage.setItem('loggedIn', 'true');

}

export const setLoggedIn = (loggedIn: boolean) => {
    localStorage.setItem('loggedIn', JSON.stringify(loggedIn));

}

export const setUser = ({
    email,
    accessToken
}: { email: string, accessToken: string }) => {
    localStorage.setItem('email', email);
    localStorage.setItem('accessToken', accessToken);
    return {
        email: email,
        accessToken: accessToken
    }
}

export const logout = () => {
    localStorage.removeItem('email');
    localStorage.removeItem('accessToken');
    localStorage.removeItem('loggedIn');
    localStorage.removeItem('token');
}

export const getUser = (): User => {
    const email = localStorage.getItem('email')!;
    const accessToken = localStorage.getItem('accessToken')!;
    return {
        email: email,
        accessToken: accessToken
    }
}


export function ProtectedPage({ children, pageId, showPopUp = true }: { children: any, pageId: string, showPopUp?: boolean}) {
    // const [loggedIn, setLoggedIn] = React.useState(false);
    // const [loading, setLoading] = React.useState(true);
    // const [access, setAccess] = React.useState(true);
    // React.useEffect(() => {
    //     CheckAccess();
    // }, []);
    // return (
    //     <div style={{
    //         width: '100%',
    //         height: '100%',
    //         display:'unset'
    //     }}>
    //         {
    //             loading ? <Loading />: access ? children : <Navigate to="/login" />
    //         }
    //     </div>
    // )

    // async function CheckAccess(): Promise<boolean> {
        
    //     try{
    //     const res =await checkAccess(pageId.replace("/",""));

    //     setLoading(false);
    //     if (res.status === true) {

    //         setAccess(true);
    //         return true;
    //     }
    //     else {

    //         // show popup

    //           setAccess(false);
    //           showPopUp &&  swal("Access Denied",`Sorry, you do not have a subscription for this page. Please write to ${mail} to subscribe.`,"warning" );
    //         return false;
    //     }

    // }     catch(err){
    //     showPopUp &&   swal("Oops !",`Please Try Again. If the issue persist please send a mail to ${mail}`,"warning" );
        
        

    //     return false;
    // }}
    return children;
}

async function CheckAccess(pageName: string): Promise<boolean> {

    try{
    const res =await buildHttpReq({
        endpoint: '/verify_access',
        method: 'POST',
        body:{
            page: pageName,
            email: getUser().email,
            token: getUser().accessToken
        }
    })

    if (res.status === true) {

        return true;
    }
    else {

        // show popup
        swal("Access Denied",`Sorry, you do not have a subscription for this page. Please write to ${mail} to subscribe.`,"warning" );
        return false;
    }

}     catch(err){
    swal("Oops !",`Please Try Again. If the issue persist please send a mail to ${mail}`,"warning" )


    return false;
}}